// @flow
import { attachmentActions } from './attachmentActionCreator';

const initialState = {
  uploadFilesSelected: []
};

const attachmentReducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case attachmentActions.Set_Upload_Files_Selected:
      return Object.assign({}, state, {
        uploadFilesSelected: state.uploadFilesSelected.concat(action.payload)
      });
    case attachmentActions.Remove_Attachment_file:
      return Object.assign({}, state, {
        uploadFilesSelected: action.payload
      });
    case attachmentActions.FLUSH_STATE:
      return Object.assign({}, state, {
        uploadFilesSelected: action.payload
      });
    default:
      return state;
  }
};

export default attachmentReducer;
